/*
 * Action Types
 */
export enum AutomaticChargeTypes {
  GET_AUTOMATIC_CHARGE_STATUS_REQUEST = '@automaticCharge/GET_AUTOMATIC_CHARGE_STATUS_REQUEST',
  GET_AUTOMATIC_CHARGE_STATUS_SUCCESS = '@automaticCharge/GET_AUTOMATIC_CHARGE_STATUS_SUCCESS',
  GET_AUTOMATIC_CHARGE_STATUS_FAILURE = '@automaticCharge/GET_AUTOMATIC_CHARGE_STATUS_FAILURE',

  ACCEPT_AUTOMATIC_CHARGE_CONTRACT_REQUEST = '@automaticCharge/ACCEPT_AUTOMATIC_CHARGE_CONTRACT_REQUEST',
  ACCEPT_AUTOMATIC_CHARGE_CONTRACT_SUCCESS = '@automaticCharge/ACCEPT_AUTOMATIC_CHARGE_CONTRACT_SUCCESS',
  ACCEPT_AUTOMATIC_CHARGE_CONTRACT_FAILURE = '@automaticCharge/ACCEPT_AUTOMATIC_CHARGE_CONTRACT_FAILURE',

  ENABLE_AUTOMATIC_CHARGE_REQUEST = '@automaticCharge/ENABLE_AUTOMATIC_CHARGE_REQUEST',
  ENABLE_AUTOMATIC_CHARGE_SUCCESS = '@automaticCharge/ENABLE_AUTOMATIC_CHARGE_SUCCESS',
  ENABLE_AUTOMATIC_CHARGE_FAILURE = '@automaticCharge/ENABLE_AUTOMATIC_CHARGE_FAILURE',
  UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_REQUEST = '@automaticCharge/UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_REQUEST',
  UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_SUCCESS = '@automaticCharge/UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_SUCCESS',
  UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_FAILURE = '@automaticCharge/UPDATE_AUTOMATIC_CHARGE_PAYOUT_ACCOUNT_FAILURE',

  GET_AUTOMATIC_CHARGE_DAILY_REPORT_REQUEST = '@automaticCharge/GET_AUTOMATIC_CHARGE_DAILY_REPORT_REQUEST',
  GET_AUTOMATIC_CHARGE_DAILY_REPORT_SUCCESS = '@automaticCharge/GET_AUTOMATIC_CHARGE_DAILY_REPORT_SUCCESS',
  GET_AUTOMATIC_CHARGE_DAILY_REPORT_FAILURE = '@automaticCharge/GET_AUTOMATIC_CHARGE_DAILY_REPORT_FAILURE',

  GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_REQUEST = '@automaticCharge/GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_REQUEST',
  GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_SUCCESS = '@automaticCharge/GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_SUCCESS',
  GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_FAILURE = '@automaticCharge/GET_AUTOMATIC_CHARGE_HISTORY_DETAIL_FAILURE',
}

/*
 * Data types
 */
export interface AutomaticChargePayoutAccountInterface {
  id: string;
  automaticChargeSettingId: string;
  bankCode: string;
  bankName: string;
  accountType: number;
  agency: string;
  account: string;
  pixKey: string;
  // When and by whom (supervisor name) the account was last saved; absent on older rows.
  updatedAt?: string;
  updatedByName?: string | null;
}

export interface AutomaticChargeStatusInterface {
  status: number | null;
  contractAcceptedAt: string | null;
  contractVersion: string | null;
  payoutAccount: AutomaticChargePayoutAccountInterface | null;
  // Whether the operator's PIX payment config can carry Pix Automático; enabling is refused by
  // the backend until it can.
  paymentConfigReady?: boolean;
}

export interface AutomaticChargeDailyReportInterface {
  usedDate: string;
  arrecadado: number;
  repassado: number;
  quantidadeRecargas: number;
}

export interface AutomaticChargeHistoryDetailInterface {
  hora: string;
  id: string;
  passageiro: string;
  valorDaRecarga: number;
  valorDeRepasse: number;
}

export interface AutomaticChargePayoutAccountFormInterface {
  bankCode: string;
  bankName: string;
  accountType: number;
  agency: string;
  account: string;
  pixKey: string;
}

/*
 * State type
 */
export interface AutomaticChargeState {
  readonly statusData: AutomaticChargeStatusInterface;
  readonly statusLoaded: boolean;
  readonly dailyReports: AutomaticChargeDailyReportInterface[];
  readonly historyDetail: AutomaticChargeHistoryDetailInterface[];
  readonly historyDetailTotalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
